export enum CheckoutSteps {
    SHIPPING = 'shipping',
    REVIEWANDPAYMENT = 'reviewAndPayment',
    CONFIRMATION = 'confirmation'
}